import React, { useEffect, useState } from 'react';

export default function UpgradeSuccess({ token, onNavigate, onUpdateRole }) {
  const [status, setStatus] = useState('checking'); // 'checking' | 'confirmed' | 'timeout'

  useEffect(() => {
    if (!token) { onNavigate('login'); return; }

    let attempts = 0;
    const maxAttempts = 8;

    const poll = setInterval(async () => {
      attempts++;
      try {
        // Check if DB role has been upgraded by the webhook
        const res = await fetch('/api/user/subscription', {
          headers: { Authorization: `Bearer ${token}` },
        });
        if (res.ok) {
          const data = await res.json();
          if (data.role === 'pro' || data.role === 'admin') {
            clearInterval(poll);
            // Refresh the JWT so localStorage reflects the new role
            try {
              const refreshRes = await fetch('/api/auth/refresh', {
                headers: { Authorization: `Bearer ${token}` },
              });
              if (refreshRes.ok) {
                const refreshData = await refreshRes.json();
                // Update localStorage
                try {
                  localStorage.setItem('ministry_token', refreshData.token);
                  localStorage.setItem('ministry_role', refreshData.role);
                } catch {}
                // Update app state
                if (onUpdateRole) onUpdateRole(refreshData.role, refreshData.token);
              }
            } catch {}
            setStatus('confirmed');
            return;
          }
        }
      } catch {}

      if (attempts >= maxAttempts) {
        clearInterval(poll);
        setStatus('timeout');
      }
    }, 2000);

    return () => clearInterval(poll);
  }, [token, onNavigate, onUpdateRole]);

  return (
    <div className="min-h-screen bg-gray-50 flex flex-col items-center justify-center px-4">
      <div className="bg-white rounded-2xl border border-gray-200 shadow-lg p-10 max-w-md w-full text-center">

        {status === 'checking' && (
          <>
            <div className="text-5xl mb-5 animate-pulse">⏳</div>
            <h1 className="text-2xl font-bold mb-3" style={{ color: '#1B3A5C' }}>
              Activating Your Account...
            </h1>
            <p className="text-gray-500 text-sm">
              Confirming your payment and upgrading your account. This only takes a moment.
            </p>
          </>
        )}

        {status === 'confirmed' && (
          <>
            <div className="text-6xl mb-5">🎉</div>
            <h1 className="text-2xl font-bold mb-3" style={{ color: '#1B3A5C' }}>
              Welcome to Pastor Pro!
            </h1>
            <p className="text-gray-600 leading-relaxed mb-2">
              Your account has been upgraded. You now have unlimited access to all 10 ministry tools.
            </p>
            <div className="mt-4 mb-6 p-4 rounded-xl" style={{ backgroundColor: '#FEF3C7' }}>
              <p className="text-sm font-semibold" style={{ color: '#92400E' }}>
                ⭐ Pastor Pro is now active on your account
              </p>
            </div>
            <button
              onClick={() => onNavigate('dashboard')}
              className="w-full py-3 rounded-xl text-white font-bold text-base transition-opacity hover:opacity-90"
              style={{ backgroundColor: '#C8921A' }}
            >
              Start Using Your Tools →
            </button>
            <button
              onClick={() => onNavigate('profile')}
              className="mt-3 w-full py-2.5 text-sm text-gray-400 hover:text-gray-600 transition-colors"
            >
              Manage subscription in Profile
            </button>
          </>
        )}

        {status === 'timeout' && (
          <>
            <div className="text-5xl mb-5">✅</div>
            <h1 className="text-2xl font-bold mb-3" style={{ color: '#1B3A5C' }}>
              Payment Received!
            </h1>
            <p className="text-gray-600 leading-relaxed mb-6">
              Your payment was successful. Your account upgrade may take a moment to process.
              Please sign out and back in to see your Pro status.
            </p>
            <button
              onClick={() => onNavigate('dashboard')}
              className="w-full py-3 rounded-xl text-white font-bold text-base transition-opacity hover:opacity-90 mb-3"
              style={{ backgroundColor: '#C8921A' }}
            >
              Go to Dashboard
            </button>
            <button
              onClick={() => onNavigate('login')}
              className="w-full py-2.5 text-sm text-gray-400 hover:text-gray-600 transition-colors"
            >
              Sign out and back in to refresh
            </button>
          </>
        )}

      </div>
    </div>
  );
}
